import { inject } from '@angular/core'
import { CanActivateFn, Router, UrlTree } from '@angular/router'
import { AcademyService } from '../../academy/academy.service'
import { UserRole } from '../../shared/interfaces/user.interface'
import { AuthService } from '../services/auth.service'

/**
 * An academy director's Home is their Academy Overview (CC, 18/10/2026). The server decides who
 * that is (GET /v2/academy): a director who represents a club, holds at least two of its youth
 * teams and nothing outside it. Competition, group and national-team directors keep the
 * Competitions page, and so does anyone when the question fails.
 *
 * Returns a UrlTree rather than navigating, for the reason in home-redirect.guard.ts.
 */
export const academyLandingGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const auth = inject(AuthService)
  const router = inject(Router)
  const academy = inject(AcademyService)

  const user = auth.currentUser()
  if (user?.role !== UserRole.DIRECTOR) return true
  const landing = await academy.loadLanding(user.id)
  return landing.landing ? router.createUrlTree(['/academy']) : true
}
